// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"275bf20c","455":"5f329559","488":"751c007a","977":"27755bb4"}[chunkId] + ".chunk.js";
};